var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "new-tag-dialog" }, [
    _c("div", { staticClass: "title" }, [
      _c("span", {
        staticClass: "el-icon-arrow-left",
        on: { click: _vm.back },
      }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.newTagTitle))]),
      _vm._v(" "),
      _c("span", { staticClass: "el-icon-close rt", on: { click: _vm.close } }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "search" },
      [
        _c("el-input", {
          attrs: {
            maxlength: 10,
            size: "mini",
            placeholder: "输入标签名，最多十个字符",
          },
          model: {
            value: _vm.input,
            callback: function ($$v) {
              _vm.input = $$v
            },
            expression: "input",
          },
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "checked-color",
          style: { background: _vm.showBgColor },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "color-box" },
      _vm._l(_vm.colorList, function (item, index) {
        return _c("span", {
          key: index,
          style: { background: item },
          on: {
            click: function ($event) {
              return _vm.changeColor(item)
            },
          },
        })
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "footer" },
      [
        _c(
          "el-button",
          {
            directives: [
              {
                name: "debounce",
                rawName: "v-debounce",
                value: _vm.tagCreateSubmit,
                expression: "tagCreateSubmit",
              },
            ],
            attrs: { type: "primary", size: "medium" },
          },
          [_vm._v("保存")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          { attrs: { size: "medium" }, on: { click: _vm.tagCancel } },
          [_vm._v("取消")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }